<!-- src/layout/Download.vue  下载中心：参考 qishui.com 布局（左品牌+三端下载按钮 / 右 AI 生成产品展示图） -->
<template>
  <div class="dl-page">
    <!-- 顶栏：logo + 在线使用 -->
    <header class="dl-nav">
      <div class="dl-nav-brand" @click="goHome">
        <span class="brand-dot"></span>
        <span class="brand-name">抖数君</span>
      </div>
      <button class="nav-use-btn" @click="goHome">在线使用</button>
    </header>

    <!-- Hero：左品牌下载区 + 右主界面窗口 -->
    <main class="dl-hero">
      <section class="hero-left">
        <div class="brand-row">
          <span class="brand-logo">
            <svg viewBox="0 0 24 24" width="52" height="52" aria-hidden="true">
              <defs>
                <linearGradient id="lg" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0" stop-color="#22d3ee"/><stop offset="1" stop-color="#a855f7"/>
                </linearGradient>
              </defs>
              <rect x="1.5" y="1.5" width="21" height="21" rx="6" fill="url(#lg)"/>
              <path d="M7 15.5V9.2c0-.7.5-1.2 1.2-1.2h4.1c1.9 0 3.2 1.1 3.2 3.75S14.1 15.5 12.3 15.5H7z"
                    fill="none" stroke="#fff" stroke-width="1.7" stroke-linejoin="round"/>
              <circle cx="15.6" cy="8.6" r="1.15" fill="#fff"/>
            </svg>
          </span>
          <h1 class="brand-title">抖数君</h1>
        </div>
        <p class="brand-sub">短视频数据分析 · AI 优化建议平台</p>

        <div class="dl-btns">
          <button class="dl-btn-primary" @click="download('pc')">
            <svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true">
              <path fill="currentColor" d="M3 5.5l7.2-1v6.9H3V5.5zm0 13l7.2 1v-6.8H3v5.8zM11.4 4.3L21 3v8.4h-9.6V4.3zm0 15.4l9.6 1.3v-8.3h-9.6V19.7z"/>
            </svg>
            下载 Windows 桌面版
          </button>
          <div class="dl-btn-row">
            <button class="dl-btn-ghost" @click="download('android')">
              <svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true">
                <path fill="currentColor" d="M7.2 9.2a.9.9 0 1 1 0-1.8.9.9 0 0 1 0 1.8zm9.6 0a.9.9 0 1 1 0-1.8.9.9 0 0 1 0 1.8zM6.3 8.6h11.4c.5 0 .9.4.9.9v5.2c0 .8-.6 1.4-1.4 1.4h-.5v2.6a1.1 1.1 0 1 1-2.2 0v-2.6h-5v2.6a1.1 1.1 0 1 1-2.2 0v-2.6h-.5c-.8 0-1.4-.6-1.4-1.4V9.5c0-.5.4-.9.9-.9zM8 4.4l-.9-1.5a.3.3 0 0 1 .5-.3l1 1.6a6.7 6.7 0 0 1 6.8 0l1-1.6a.3.3 0 0 1 .5.3L16 4.4c1.6 1 2.6 2.5 2.6 4.2H5.4c0-1.7 1-3.2 2.6-4.2z"/>
              </svg>
              Android
            </button>
            <button class="dl-btn-ghost" @click="download('ios')">
              <svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true">
                <path fill="currentColor" d="M16.6 12.8c0-2.3 1.9-3.4 2-3.5-1.1-1.6-2.8-1.8-3.4-1.8-1.4-.1-2.8.8-3.5.8-.7 0-1.8-.8-3-.8-1.5 0-3 .9-3.8 2.3-1.6 2.8-.4 7 1.2 9.3.8 1.1 1.7 2.4 2.9 2.3 1.2 0 1.6-.7 3-.7s1.8.7 3 .7c1.3 0 2.1-1.1 2.8-2.3.9-1.3 1.3-2.6 1.3-2.7 0 0-2.5-1-2.5-3.6zM14.3 5.4c.6-.8 1.1-1.9 1-3-.9 0-2.1.6-2.7 1.4-.6.7-1.2 1.8-1 2.9 1 .1 2.1-.5 2.7-1.3z"/>
              </svg>
              iOS
            </button>
          </div>
        </div>

        <div class="hero-links">
          <a @click.prevent="scrollToGuide" href="javascript:;">安装说明？</a>
          <a @click.prevent="goHome" href="javascript:;">常见问题？</a>
        </div>
      </section>

      <!-- 右侧：AI 生成产品展示图（深色笔记本数据界面 + 悬浮手机，综合真实功能界面风格） -->
      <section class="hero-right">
        <img class="showcase-img" src="@/assets/images/download-showcase.jpg" alt="抖数君多端数据界面预览">

        <div class="hero-glow g1"></div>
        <div class="hero-glow g2"></div>
      </section>
    </main>

    <!-- 安装说明 -->
    <section class="dl-guide" ref="guide">
      <h2 class="guide-title">安装说明</h2>
      <div class="guide-cards">
        <div class="g-card">
          <img class="g-card-icon" src="@/assets/images/dl-windows.png" alt="Windows">
          <h3>Windows 桌面版</h3>
          <p>1. 下载并解压 zip 压缩包</p>
          <p>2. 双击「抖数君桌面版.exe」运行</p>
          <p>3. 首次运行如遇 SmartScreen 提示，点击「仍要运行」</p>
        </div>
        <div class="g-card">
          <img class="g-card-icon" src="@/assets/images/dl-android.png" alt="Android">
          <h3>Android</h3>
          <p>1. 下载 APK 安装包</p>
          <p>2. 允许「安装未知来源应用」</p>
          <p>3. 完成安装后登录使用</p>
        </div>
        <div class="g-card">
          <img class="g-card-icon" src="@/assets/images/dl-ios.png" alt="iOS">
          <h3>iOS（需自签）</h3>
          <p>1. 下载 ipa 到电脑</p>
          <p>2. 用爱思助手 / AltStore 签名并安装到手机</p>
          <p>3. 首次启动需在 设置→通用→VPN与设备管理 中信任开发者证书</p>
        </div>
      </div>
    </section>

    <footer class="dl-footer">© {{ year }} 抖数君 · 作品分析建议优化平台</footer>
  </div>
</template>

<script>
// 下载中心页：三端安装包由后端站点根 /downloads/ 目录托管（php public）
export default {
  name: 'DownloadPage',
  data() {
    return {
      year: new Date().getFullYear(),
      dlBase: process.env.NODE_ENV === 'production' ? 'https://doushujun.me' : 'http://192.168.31.100:8000'
    };
  },
  methods: {
    goHome() { window.location.href = '/'; }, // 回首页（在线使用）
    download(kind) { // 三端下载：经后端统计接口（记录下载量）→ 302 到真实安装包
      window.open(this.dlBase + '/api/app/download?platform=' + kind, '_blank');
    },
    scrollToGuide() { // 平滑滚动到安装说明
      this.$refs.guide && this.$refs.guide.scrollIntoView({ behavior: 'smooth' });
    }
  }
};
</script>

<style scoped>
.dl-page {
  position: relative;
  min-height: 100vh;
  background: #050507;
  color: #fff;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  overflow-x: hidden;
}
/* 全页科技风背景（AI 生成的三端设备 + 下载云视觉），fixed 铺底低透明度不抢内容 */
.dl-page::before {
  content: '';
  position: fixed;
  inset: 0;
  z-index: 0;
  background: url('~@/assets/images/download-hero.jpg') center top / cover no-repeat;
  opacity: .38;
  pointer-events: none;
}
.dl-page > * { position: relative; z-index: 1; }

/* ===== 顶栏 ===== */
.dl-nav {
  position: sticky; top: 0; z-index: 10;
  display: flex; align-items: center; justify-content: space-between;
  height: 56px; padding: 0 28px;
  background: rgba(5,5,7,.72); backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(255,255,255,.06);
}
.dl-nav-brand { display: flex; align-items: center; gap: 9px; cursor: pointer; }
.brand-dot {
  width: 26px; height: 26px; border-radius: 8px;
  background: linear-gradient(135deg, #22d3ee, #a855f7);
  box-shadow: 0 0 14px rgba(34,211,238,.55);
}
.brand-name { font-size: 19px; font-weight: 700; letter-spacing: 1px; }
.nav-use-btn {
  height: 34px; padding: 0 20px; border: none; border-radius: 17px;
  background: #fff; color: #111; font-size: 13px; font-weight: 600; cursor: pointer;
  transition: transform .15s ease, box-shadow .15s ease;
}
.nav-use-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(255,255,255,.18); }

/* ===== Hero ===== */
.dl-hero {
  position: relative;
  display: flex; align-items: center; gap: 30px;
  max-width: 1200px; margin: 0 auto;
  padding: 60px 28px 40px;
}
.hero-left { flex: 0 0 340px; }
.brand-row { display: flex; align-items: center; gap: 14px; }
.brand-title { margin: 0; font-size: 54px; font-weight: 800; letter-spacing: 2px; }
.brand-sub {
  margin: 14px 0 34px; font-size: 14px; letter-spacing: 5px;
  color: rgba(255,255,255,.55);
}
.dl-btns { display: flex; flex-direction: column; gap: 12px; }
.dl-btn-primary, .dl-btn-ghost {
  display: flex; align-items: center; justify-content: center; gap: 9px;
  height: 42px; border-radius: 21px; border: none; cursor: pointer;
  font-size: 14px; font-weight: 600;
  transition: transform .15s ease, box-shadow .15s ease, background .15s ease;
}
.dl-btn-primary { width: 100%; background: #fff; color: #101014; }
.dl-btn-primary:hover { transform: translateY(-2px); box-shadow: 0 10px 30px rgba(255,255,255,.22); }
.dl-btn-row { display: flex; gap: 12px; }
.dl-btn-ghost {
  flex: 1; background: rgba(255,255,255,.10); color: #fff;
  border: 1px solid rgba(255,255,255,.16);
}
.dl-btn-ghost:hover { background: rgba(255,255,255,.18); transform: translateY(-2px); }
.hero-links { margin-top: 26px; display: flex; gap: 22px; }
.hero-links a { color: rgba(255,255,255,.5); font-size: 13px; text-decoration: none; }
.hero-links a:hover { color: #fff; }

/* ===== 右侧产品展示图（AI 生成）：圆角卡片 + 大投影，底层 hero-glow 光晕透边 ===== */
.showcase-img {
  position: relative; z-index: 2;
  width: 100%; max-width: 660px; display: block;
  border-radius: 16px;
  box-shadow: 0 30px 80px rgba(0, 0, 0, .6), 0 0 40px rgba(34, 211, 238, .10), 0 0 40px rgba(168, 85, 247, .10);
}
/* 小屏：压低最大宽度并缩小光晕 */
@media (max-width: 960px) {
  .showcase-img { max-width: 520px; margin: 0 auto; }
}

/* ===== 安装说明 ===== */
.dl-guide { max-width: 1200px; margin: 0 auto; padding: 30px 28px 60px; }
.guide-title { margin: 0 0 22px; font-size: 22px; font-weight: 700; }
.guide-cards { display: flex; gap: 16px; }
.g-card {
  flex: 1; background: rgba(255,255,255,.045);
  border: 1px solid rgba(255,255,255,.08); border-radius: 14px; padding: 20px 22px;
}
/* 平台徽标插画：圆形裁切 + 青紫渐变描边光圈 */
.g-card-icon {
  width: 92px; height: 92px; object-fit: cover; border-radius: 50%;
  margin-bottom: 12px; display: block;
  border: 2px solid rgba(103, 232, 249, .35);
  box-shadow: 0 0 22px rgba(34, 211, 238, .22), 0 0 22px rgba(168, 85, 247, .18);
}
.g-card h3 { margin: 0 0 12px; font-size: 15px; color: #67e8f9; }
.g-card p { margin: 7px 0; font-size: 13px; line-height: 1.7; color: rgba(255,255,255,.65); }

.dl-footer { text-align: center; padding: 26px 0 34px; font-size: 12px; color: rgba(255,255,255,.35); }

/* ===== 响应式 ===== */
@media (max-width: 960px) {
  .dl-hero { flex-direction: column; padding-top: 40px; }
  .hero-left { flex: none; width: 100%; max-width: 360px; text-align: center; }
  .brand-row { justify-content: center; }
  .brand-title { font-size: 42px; }
  .hero-links { justify-content: center; }
  .hero-right { width: 100%; padding: 10px 0 6px; }
  .guide-cards { flex-direction: column; }
}
</style>
